import './Verified.sass';

import React, { FC, useCallback } from 'react';

import { useCurrentUserInfo, useGroupInfo, useUserInfo } from '$hooks';
import {
  IcDiamond22,
  IcSnowflake16,
  IcSubscriptionExtra28,
  IcTelegram16,
  IcVerified16,
} from '$assets';
import { classNames, isChristmasHolidays } from '$utils';
import { VerifiedProps } from './Verified.interface';
import { Badge } from '$uikit';

export const Verified: FC<VerifiedProps> = ({
  objectId,
  sponsor = false,
  large = false,
}) => {
  const user = useUserInfo(objectId);
  const group = useGroupInfo(-objectId);
  const currentUser = useCurrentUserInfo();

  const currentUserIsModel = currentUser?.verified > 0;

  const handleClick = useCallback((e) => {
    //e.preventDefault();
    //showModal('post2945');
  }, []);

  if (
    objectId === 1308 ||
    objectId === 526969 ||
    objectId === 87344 ||
    objectId === 1787919 ||
    user?.isService
  ) {
    return <div className="Verified__team">Team</div>;
  }

  const isGold = objectId === 915866;

  return (
    <div
      onClick={handleClick}
      className={classNames('Verified', {
        large,
      })}
    >
      {currentUserIsModel && sponsor ? (
        <IcSubscriptionExtra28 />
      ) : (objectId > 0 && !!user?.verified) || (objectId < 0 && !!group?.verified) ? (
        user?.ai ? (
          <div className="Verified__ai">AI</div>
        ) : (
          <IcVerified16 color={isGold ? '#FFA526' : '#32afed'} />
        )
      ) : (
        objectId > 0 &&
        user?.hasSubscription &&
        !user?.isTelegramUser &&
        (isChristmasHolidays() ? <IcSnowflake16 /> : <IcDiamond22 />)
      )}
      {currentUserIsModel && objectId > 0 && user?.isTelegramUser && <IcTelegram16 />}
    </div>
  );
};
